/* eslint handle-callback-err: "warn" */
import { login, getInfo, getService } from '@/api/login'
import { getBalance } from '@/api/ewallet'

// import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    id: '',
    token: '',
    username: '',
    name: '',
    email: '',
    description: {},
    avatar: '',
    confirmed: false,
    role: '',
    awakRole: '',
    userData: {},
    balance: 0
  },
  getters: {
    id: state => state.id,
    token: state => state.token,
    avatar: state => state.avatar,
    username: state => state.username,
    name: state => state.name,
    email: state => state.email,
    description: state => state.description,
    confirmed: state => state.confirmed,
    role: state => state.role,
    awakRole: state => state.awakRole,
    userData: state => state.userData,
    balance: state => state.balance
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_DESCRIPTION: (state, description) => {
      state.description = description
    },
    SET_CONFIRMED: (state, confirmed) => {
      state.confirmed = confirmed
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_AWAK_ROLE: (state, awakRole) => {
      state.awakRole = awakRole
    },
    SET_USER_DATA: (state, userData) => {
      state.userData = userData
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    }
  },

  actions: {
    Login({ dispatch, commit }, userInfo) {
      // try {
      //   const username = userInfo.username.trim()

      //   const data = await login(username, userInfo.password)

      //   if (data.user.role && data.user.role.type) {
      //     commit('SET_ROLE', data.user.role.type)
      //   } else {
      //     throw new Error('getInfo: role not found !')
      //   }
      //   commit('SET_TOKEN', data.jwt)
      //   // commit('SET_NAME', data.user.name)
      //   commit('SET_USERNAME', data.user.username)
      //   commit('SET_EMAIL', data.user.email)
      //   commit('SET_CONFIRMED', data.user.confirmed)

      //   const service = await getService()
      //   if (service.package === undefined) {
      //     service.package = 'none'
      //   }
      //   commit('SET_AWAK_ROLE', service.package)
      //   if (service.userData !== undefined) {
      //     commit('SET_USER_DATA', service.userData)
      //   }

      //   // const wallet = await getBalance()
      //   commit('SET_BALANCE', 10)
      // } catch (error) {
      //   throw error
      // }
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response
          if (data.user.role && data.user.role.type) {
            commit('SET_ROLE', data.user.role.type)
          } else {
            reject('getInfo: role not found !')
          }
          commit('SET_TOKEN', data.jwt)
          // commit('SET_NAME', data.user.name)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_CONFIRMED', data.user.confirmed)
          getService().then(response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            if (data2.userData !== undefined) {
              commit('SET_USER_DATA', data2.userData)
            }
            resolve({ awakRole: data2.package, ...data })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    SignInPlatform({ dispatch, commit }, data) {
      return new Promise(async(resolve, reject) => {
        commit('SET_ROLE', 'authenticated')
        commit('SET_TOKEN', data.jwt)
        // console.log('testlog2')
        // console.log(data.lmao)
        // console.log(data.ref)
        // console.log(await data.ref.$gAuth.isAuthorized)
        // console.log(await data.ref.$gAuth.getAuthCode())
        // console.log(data)
        // commit('SET_NAME', data.user.name)
        commit('SET_USERNAME', data.profile.sd)
        commit('SET_EMAIL', data.user.email)
        commit('SET_CONFIRMED', data.user.confirmed)
        getService().then(response2 => {
          const data2 = response2
          if (data2.package === undefined) {
            data2.package = 'none'
          }
          commit('SET_AWAK_ROLE', data2.package)
          if (data2.userData !== undefined) {
            commit('SET_USER_DATA', data2.userData)
          }
          resolve({ awakRole: data2.package, ...data })
        })
      })
    },
    GetBalance({ commit, state }) {
      return new Promise((resolve, reject) => {
        getBalance().then(response => {
          commit('SET_BALANCE', response.balance)
          resolve({
            balance: response.balance
          })
        }).catch(error => {
          // console.log(error)
          commit('SET_BALANCE', 0)
          resolve({
            balance: 0
          })
        })
      })
    },
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.username).then(async response => {
          const data = response
          if (data.role && data.role.type) {
            commit('SET_ROLE', data.role.type)
          } else {
            reject('getInfo: role not found !')
          }
          // console.log('testlog')
          // console.log(await Vue.component.gAuth.isAuthorized)
          // console.log(await Vue.component.gAuth.getAuthCode())
          // console.log(data)
          // commit('SET_NAME', data.user.name)
          commit('SET_ID', data._id)
          if (state.username === '') {
            commit('SET_USERNAME', data.username)
          }
          commit('SET_EMAIL', data.email)
          commit('SET_DESCRIPTION', data.description)
          commit('SET_CONFIRMED', data.confirmed)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.username}`)
          getService().then(response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            if (data2.userData !== undefined) {
              commit('SET_USER_DATA', data2.userData)
            }
            resolve({ awakRole: data2.package, ...data })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_NAME', '')
        commit('SET_USERNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_AVATAR', '')
        commit('SET_DESCRIPTION', '')
        commit('SET_CONFIRMED', '')
        commit('SET_AWAK_ROLE', '')
        commit('SET_USER_DATA', {})
        commit('SET_BALANCE', 0)
        commit('SET_REDIRECTURL', null)
        resolve()
      })
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        // removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js